module.exports = __webpack_public_path__ + "img/location_off.49b7752f.svg";